import * as tslib_1 from "tslib";
import { EntityStore, StoreConfig } from '@datorama/akita';
import * as i0 from "@angular/core";
let AppStore = class AppStore extends EntityStore {
    constructor() {
        super();
    }
};
AppStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppStore_Factory() { return new AppStore(); }, token: AppStore, providedIn: "root" });
AppStore = tslib_1.__decorate([
    StoreConfig({ name: 'app' })
], AppStore);
export { AppStore };
